import React from 'react';
import { TypographyProps } from '../Typography';

export const defaultContextValue: {
  linkColor: 'blue' | 'inherit';
  testId: string;
  typography: TypographyProps;
} = {
  linkColor: 'blue',
  testId: 'infoList',
  typography: {
    variant: 'body2',
    color: 'neutrals-n7',
    whiteSpace: 'nowrap',
    ellipsize: true,
  },
};

export const Context = React.createContext(defaultContextValue);
